<template>
  <div>

     <v-snackbar v-model="successSnack" :timeout="3000" top color="white">
        <span class="green--text">{{sucMsg}}</span>
      </v-snackbar>

    <!-- Just an image -->
    <div class="container">
      <nav class="navbar navbar-expand-lg navbar-light">
       <img src="/logo.png" width="60" height="40" class="d-inline-block align-top img-f" alt="logo" loading="lazy">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ml-auto py-4 py-md-0">
            <li class="nav-item px-lg-2 text-color">
              <router-link to="/" class="nav-link" href="#">
              <span class="d-inline-block d-sm-block d-md-none icon-width mr-2"><i class="fas fa-home"></i></span>Home</router-link>
            </li>
            
            <li class="nav-item px-lg-2">
              <router-link to="/login" class="nav-link"  style="">
               <span class="d-inline-block d-sm-block d-md-none icon-width mr-2"><i class="fas fa-sign-in-alt"></i></span>Sign In</router-link>
            </li>
          </ul>
        </div>
      </nav>

      <!-- =================Login panel====================================== -->
      <div class="row">

        <!-- first column -->
        <div class="col-sm-12 col-lg-6 d-none d-md-block mt-5 mb-12">
          <img src="/pics1.svg" alt="login" class="img-fluid mt-5"  />
        </div>


        <!-- second column -->
        <div class="col-sm-12 col-lg-6">

          <div class="text-center mt-4">
            <h6 style="font-size: 25px;" class="">Please enter your personal information</h6>
          </div>
          <!-- <p class="red--text text-center">You are using Kure-Ojo Oluwashina referral code</p> -->
          <form style="width: 80%; margin: auto;">

              <div class="form-group">
                <label for="email">Email address</label>
                <input type="email" class="form-control input-style" id="email"
                v-bind:class="{'form-control' : true, 'is-invalid' : !validEmail(email) && emailBlured}"
                v-on:blur="emailBlured = true"
                 v-model="email">
                 <div class="invalid-feedback">A valid email is required</div>
              </div>
              
              <div class="form-group">
                <label for="fname">Firstname</label>
                <input type="text" class="form-control input-style" id="fname" required v-model="firstname">
              </div>
              <div class="form-group">
                <label for="lname">Lastname</label>
                <input type="text" class="form-control input-style" id="lname" required v-model="lastname">
              </div>

              <div class="form-group">
                <label for="password">Password</label>
                <div class="input-group mb-2" id="show_hide_password">
                    <input :type="show1 ? 'text' : 'password'" class="form-control input-style" id="password" v-model="password">
                    <div class="input-group-prepend">
                        <div class="input-group-text pa-0">
                            <v-btn icon>
                              <i class="fa fa-eye-slash" aria-hidden="true" @click="show1 = !show1" v-if="!show1"></i>
                              <i class="fa fa-eye" aria-hidden="true" @click="show1 = !show1" v-if="show1"></i>
                            </v-btn>
                        </div>
                      </div>
                  </div>
              </div>
              <div class="form-group">
                <label for="cpassword">Confirm Password</label>
                <div class="input-group mb-2" id="show_hide_password">
                    <input :type="show2 ? 'text' : 'password'" class="form-control input-style"
                     v-bind:class="{'is-invalid' : !confirmPass(cpassword) && passwordBlured}"
                      v-on:blur="passwordBlured = true"
                     id="cpassword" v-model="cpassword">
                    <div class="input-group-prepend">
                        <div class="input-group-text pa-0">
                            <v-btn icon>
                              <i class="fa fa-eye-slash" aria-hidden="true" @click="show2 = !show2" v-if="!show2"></i>
                              <i class="fa fa-eye" aria-hidden="true" @click="show2 = !show2" v-if="show2"></i>
                            </v-btn>
                        </div>
                      </div>
                       <div class="myPass">Passwords don't match</div>
                  </div>
                 
              </div>
            <div class="form-group form-check" style="margin-top: 10px;">
              <input type="checkbox" class="form-check-input" id="exampleCheck1" v-model="agree">
              <label class="form-check-label" for="exampleCheck1">I've read, understood and agreed to the <a style="color:#48c074;">Privacy, Terms and Conditions</a></label>
            </div>
            <button type="submit" :disabled="isDisabled" class="btn mt-2" style="width: 100%; background-color:#48c074; color:white" id="signIn" @click="register($event)" >Sign Up <span class="fa fa-circle-o-notch fa-spin" v-if="loading"></span></button>
          </form>



          <div class="text-center mt-3">
            <p>Already have an account? <router-link to="/login" style="text-decoration: none;color:#48c074;">Click to login</router-link></p> 
          </div>

        </div>

        
      </div>
    </div>
        
    

  </div>
</template>

<script>
export default {
  data(){
    return{
      show1:false,
      show2:false,
      loading: false,
      email:'',
      emailBlured: false,
      passwordBlured: false,
      valid: false,
      passValid: false,
      firstname:'',
      lastname:'',
      password:'',
      cpassword:'',
      agree: false,
      emailRules:[
        v => !!v || 'Email is required',
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid',
      ],
      sucMsg:'',
      successSnack: false,
      referralCode:''
    }
  },
  methods:{
    validate: function(){
      this.emailBlured = true;
      this.passwordBlured = true
      if(this.validEmail(this.email)){
        this.valid = true
      }
      if(this.confirmPass(this.cpassword)){
        this.passValid = true
      }
    },
    validEmail: function(email){
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      return re.test(email.toLowerCase())
    },
    confirmPass: function(cpassword){
      return this.password === cpassword
    },
    register(event){
      event.preventDefault()
      this.validate();
      this.confirmPass();
      
      if(this.valid && this.passValid){
        this.loading = true
        alert("submitted")
        this.$store.dispatch("Register", {
        "email": this.email,
        "password": this.password,
        "firstname": this.firstname,
        "lastname": this.lastname,
        "referralCode":this.referralCode,
      })
      .then(()=>{
       this.loading = false
       this.successSnack = true
       this.sucMsg = "Registration successful!, Kindly login to continue."
       this.emailBlured = false
       this.passwordBlured = false
      })
      .catch((error)=>{
        this.msg= error.response.data.message.toUpperCase()
        this.errorMessage =true
        this.loading = false
      })
      }
    }
  },
  computed:{
    isDisabled: function(){
      return this.firstname.length == "" || this.lastname.length == "" || this.email.length == ""  || this.password.length == "" || this.cpassword.length == "" || !this.agree;
    }
  },
  created(){
    let code = this.$route.query.referralCode
    if (code){
      this.referralCode = code
    }
  }
}
</script>

<style scoped>
.v-application ul{
  padding: 0px;
}
.myPass{
  display: none;
  width: 100%;
  margin-top: .25rem;
  font-size: 80%;
  color: #dc3545;
}
.is-invalid~.myPass{
  display: block;
}
/* navigation styles */
.nav-item:after{
	position: absolute;
	bottom: -5px;
	left: 40px;
    width: 5px;
    border-radius: 50%;
	height: 5px;
    content: '';
	background-color: #48c074;
	opacity: 0;
    transition: all 200ms linear;
}
.nav-item:hover:after{
	bottom: 0;
	opacity: 1;
}
.nav-item.active:hover:after{
	opacity: 0;
}
.nav-item{
	position: relative;
    transition: all 200ms linear;
}

.navbar-toggler {
	float: right;
	border: none;
	padding-right: 0;
}
.navbar-toggler:active,
.navbar-toggler:focus {
	outline: none;
}
.navbar-light .navbar-toggler-icon {
	width: 24px;
	height: 17px;
	background-image: none;
	position: relative;
	border-bottom: 1px solid #777;
    transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after, 
.navbar-light .navbar-toggler-icon:before{
	width: 24px;
	position: absolute;
	height: 1px;
	background-color: #777;
	top: 0;
	left: 0;
	content: '';
	z-index: 2;
    transition: all 300ms linear;
}
.navbar-light .navbar-toggler-icon:after{
	top: 8px;
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:after {
	transform: rotate(45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon:before {
	transform: translateY(8px) rotate(-45deg);
}
.navbar-toggler[aria-expanded="true"] .navbar-toggler-icon {
	border-color: transparent;
}
 .input-style{
    padding: 20px 20px;
  }
  .input-style:focus{
    border-color: rgba(50, 54, 67, 0.2);
    box-shadow: 0px 5px 30px rgba(50, 54, 67, 0.2);
    outline: 0 none;
}

  
@media screen and (max-width: 768px) {
   .nav-item:after{
    visibility: hidden
  }
}
</style>